import { onBeforeRouteLeave, useRoute, useRouter } from 'vue-router';
import { Route } from '../routes/routes';
import { useNotifications } from './useNotifications';
import { onMounted } from 'vue';
import { useUserStore } from '../stores/userStore';

const localStorageKey = 'forceChangePassword';

export function useForceChangePassword(registerRouteWatcher = false) {
    const route = useRoute();
    const router = useRouter();
    const userStore = useUserStore();
    const notif = useNotifications();

    function markShouldChange() {
        localStorage.setItem(localStorageKey, 'true');
    }

    function shouldChange() {
        return localStorage.getItem(localStorageKey) === 'true';
    }

    function markChanged() {
        localStorage.setItem(localStorageKey, 'false');
    }

    async function navigateToEditUser() {
        await userStore.isUserResolvedPromise;

        if (!userStore.isLoggedIn) {
            return;
        }

        await router.replace({
            name: Route.EditUser,
            params: {
                userId: userStore.user?.id,
            },
        });

        notif.showInfo('Molimo promijenite lozinku');
    }

    if (registerRouteWatcher) {
        onBeforeRouteLeave((_to, from) => {
            if (from.name === Route.EditUser && shouldChange()) {
                notif.showError('Obavezno je promijeniti lozinku');
                return false;
            }
        });
    }

    onMounted(async () => {
        if (route.name !== Route.EditUser && shouldChange()) {
            await navigateToEditUser();
        }
    });

    return {
        markShouldChange,
        markChanged,
        navigateToEditUser,
    };
}
